import { useQuery } from "@tanstack/react-query"
import { getPurchaseOrderAttachmentList } from "customerAttachments/apis"

const useGetPurchaseOrderAttachList = (orderNo: string) => {
  const { data, isLoading } = useQuery({
    enabled: !!orderNo,
    queryKey: ["purchaseAttachments", orderNo],
    queryFn: () => getPurchaseOrderAttachmentList(orderNo),
    select: (data) => data?.Data,
  })
  return { data, isLoading }
}

export default useGetPurchaseOrderAttachList
